export const TRIAL_DURATION_DAYS = 5
export const TRIAL_DAILY_LIMIT = 25